<template>
  <div id="paper" v-loading="loading">
    <top></top>
    <div class="main">
      <div class="content">
        <title-background :title="'证件申报'"></title-background>
        <div class="paper_search">
          <div class="paper_search_input">
            <span>姓名：</span>
            <el-input v-model="name" placeholder="请输入姓名"></el-input>
          </div>
          <div class="paper_search_input">
            <span>手机号：</span>
            <el-input v-model="mobile" placeholder="请输入手机号"></el-input>
          </div>
          <div class="paper_search_input">
            <span>身份证号：</span>
            <el-input v-model="id_card" placeholder="请输入身份证号"></el-input>
          </div>
          <el-button type="primary" @click="handleSearch">查询</el-button>
          <el-button class="reset" @click="handleReset">重置</el-button>
        </div>
        <div class="paper_add">
          <el-button type="primary" @click="handleAdd">+ 新建</el-button>
        </div>
        <el-table :data="tableData" stripe style="width: 100%">
          <el-table-column
            show-overflow-tooltip
            prop="declare_items_name"
            label="活动名称"
            min-width="240"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="name"
            label="姓名"
            min-width="120"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="apply_department"
            label="申领机构/部门"
            min-width="150"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="position"
            label="职位"
            min-width="150"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="id_card"
            label="身份证号"
            min-width="180"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="mobile"
            label="联系电话"
            min-width="120"
          ></el-table-column>
          <el-table-column label="头像" min-width="100">
            <template slot-scope="scope">
              <img
                v-if="scope.row.avatar"
                :src="scope.row.avatar"
                style="
                  width: 60px;
                  height: 60px;
                  object-fit: cover;
                  border-radius: 4px;
                "
              />
              <span v-else>—</span>
            </template>
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="certificate_type"
            label="证件类型"
            min-width="120"
          ></el-table-column>
          <el-table-column label="审核状态" min-width="120">
            <template slot-scope="scope">
              <el-tag type="success" v-if="scope.row.audit_status == '通过'"
                >通过</el-tag
              >
              <el-tag type="warning" v-if="scope.row.audit_status == '待审核'"
                >待审核</el-tag
              >
              <el-tag type="danger" v-if="scope.row.audit_status == '驳回'"
                >驳回</el-tag
              >
            </template>
          </el-table-column>
          <el-table-column
            prop="reject_reason"
            label="驳回原因"
            min-width="200"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="create_time"
            label="创建时间"
            min-width="200"
          ></el-table-column>
          <el-table-column label="操作" min-width="150">
            <template slot-scope="scope">
              <div class="paper_actions">
                <span
                  @click="handleEdit(scope.row)"
                  v-if="scope.row.audit_status != '通过'"
                  >编辑</span
                >
                <span
                  class="delete"
                  @click="handleDelete(scope.row)"
                  v-if="scope.row.audit_status != '通过'"
                  >删除</span
                >
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div class="paper_pagination">
          <el-pagination
            :current-page="currentPage"
            :page-size="pageSize"
            @current-change="handleCurrentPageChange"
            background
            layout="prev, pager, next"
            :total="total"
          ></el-pagination>
        </div>
      </div>
      <el-dialog
        title="证件申报"
        :visible.sync="showDialog"
        width="30%"
        @close="cancelDialog"
      >
        <el-form
          ref="formRef"
          :model="form"
          :rules="formRules"
          label-width="100px"
        >
          <el-form-item label="姓名" prop="name">
            <el-input v-model="form.name" placeholder="请输入姓名"></el-input>
          </el-form-item>
          <el-form-item label="职位" prop="position">
            <el-input
              v-model="form.position"
              placeholder="请输入职位"
            ></el-input>
          </el-form-item>
          <el-form-item label="身份证号" prop="id_card">
            <el-input
              v-model="form.id_card"
              placeholder="请输入身份证号"
            ></el-input>
          </el-form-item>
          <el-form-item label="手机号" prop="mobile">
            <el-input
              v-model="form.mobile"
              placeholder="请输入手机号"
            ></el-input>
          </el-form-item>
          <el-form-item label="头像" prop="avatar" class="paper_form_avatar">
            <singleImageUpload
              :imageSrc="form.avatar"
              @handleUploading="handleUploading"
              @handleUploadSuccess="handleUploadSuccess"
              @handlePreviewImage="handlePreviewImage"
              @handleDeleteImage="handleDeleteImage"
            ></singleImageUpload>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="cancelDialog">取 消</el-button>
          <el-button type="primary" @click="submitForm">确 定</el-button>
        </span>
      </el-dialog>
    </div>
    <maskLayer
      :text="maskLayerText"
      :show="maskLayerShow"
      :type="maskLayerType"
      :imgSrc="form.avatar"
      @handleCancelPreviewImage="handleCancelPreviewImage"
    ></maskLayer>
  </div>
</template>

<script>
import top from "../../components/top.vue";
import titleBackground from "../dataReview/json/titleBackground.vue";
import singleImageUpload from "../../components/singleImageUpload.vue";
import maskLayer from "../../components/maskLayer.vue";
import {
  getPaperCertificateList,
  addPaperCertificate,
  editPaperCertificate,
  deletePaperCertificate,
  getPaperCertificateDetail,
} from "../../api/api";
export default {
  name: "activityList",
  components: { top, titleBackground, singleImageUpload, maskLayer },
  data() {
    return {
      // 列表所需字段
      currentPage: 1,
      pageSize: 10,
      name: "",
      position: "",
      id_card: "",
      mobile: "",
      audit_status: "",
      // 总数
      total: 0,
      // 数据源
      tableData: [],
      // 加载状态
      loading: false,
      showDialog: false,
      mode: "",
      form: {
        long_id: "",
        name: "",
        position: "",
        id_card: "",
        mobile: "",
        avatar: "",
      },
      formRules: {
        name: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        position: [{ required: true, message: "请输入职位", trigger: "blur" }],
        id_card: [
          { required: true, message: "请输入身份证号", trigger: "blur" },
          {
            pattern: /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/,
            message: "身份证格式不正确",
            trigger: "blur",
          },
        ],
        mobile: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          {
            pattern: /^1[3-9]\d{9}$/,
            message: "手机号格式不正确",
            trigger: "blur",
          },
        ],
        avatar: [{ required: true, message: "请上传头像", trigger: "blur" }],
      },
      maskLayerShow: false,
      maskLayerType: "",
      maskLayerText: "",
    };
  },
  created() {
    this.getList();
  },
  methods: {
    async getList() {
      this.loading = true;
      const res = await getPaperCertificateList(
        `page_no=${this.currentPage}&page_size=${this.pageSize}&name=${this.name}&id_card=${this.id_card}&mobile=${this.mobile}`
      );
      if (res.code == 1) {
        this.total = res.data.count;
        this.tableData = res.data.lists;
      } else {
        this.$message.error(res.msg);
      }
      this.loading = false;
    },
    submitForm() {
      this.$confirm("是否确认要提交信息?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$refs.formRef.validate((valid, fields) => {
            if (valid) {
              this.handleSubmit();
            } else {
              const firstErrorField = Object.keys(fields)[0];
              const tipMsg = fields[firstErrorField][0].message;
              this.$message.error(tipMsg);
            }
          });
        })
        .catch(() => {});
    },
    async handleSubmit() {
      if (this.mode === "add") {
        const res = await addPaperCertificate(this.form);
        if (res.code == 1) {
          this.$message.success("提交成功");
          this.showDialog = false;
          this.mode === "";
          this.$refs.formRef?.resetFields();
          this.getList();
        } else {
          this.$message.error(res.msg);
        }
      } else if (this.mode === "edit") {
        const res = await editPaperCertificate(this.form);
        if (res.code == 1) {
          this.$message.success("提交成功");
          this.showDialog = false;
          this.mode === "";
          this.$refs.formRef?.resetFields();
          this.getList();
        } else {
          this.$message.error(res.msg);
        }
      }
    },
    handleAdd() {
      this.showDialog = true;
      this.mode = "add";
    },
    handleEdit(row) {
      this.showDialog = true;
      this.mode = "edit";
      this.getDetail(row.long_id);
    },
    handleDelete(row) {
      this.$confirm("是否确认要删除这条数据?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          const res = await deletePaperCertificate({
            long_id: row.long_id,
          });
          if (res.code == 1) {
            this.$message.success("删除成功");
            this.getList();
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch(() => {});
    },
    async getDetail(long_id) {
      const res = await getPaperCertificateDetail("long_id=" + long_id);
      if (res.code == 1) {
        this.form.name = res.data.name;
        this.form.position = res.data.position;
        this.form.id_card = res.data.id_card;
        this.form.mobile = res.data.mobile;
        this.form.avatar = res.data.avatar;
        this.form.long_id = res.data.long_id;
      } else {
        this.$message.error(res.msg);
      }
    },
    handleSearch() {
      this.currentPage = 1;
      this.getList();
    },
    handleReset() {
      this.name = "";
      this.mobile = "";
      this.id_card = "";
      this.currentPage = 1;
      this.getList();
    },
    handleCurrentPageChange(val) {
      this.currentPage = val;
      this.getList();
    },
    cancelDialog() {
      this.mode === "";
      this.showDialog = false;
      this.$refs.formRef?.resetFields();
    },
    handleUploading() {
      this.maskLayerShow = true;
      this.maskLayerType = "upload";
      this.maskLayerText = "正在上传中...";
    },
    handleUploadSuccess(src) {
      this.maskLayerShow = false;
      this.maskLayerType = "";
      if (src) {
        this.form.avatar = src;
      }
    },
    handlePreviewImage() {
      this.maskLayerShow = true;
      this.maskLayerType = "preview";
    },
    handleDeleteImage() {
      this.form.avatar = "";
    },
    handleCancelPreviewImage() {
      this.maskLayerShow = false;
      this.maskLayerType = "";
    },
  },
};
</script>

<style lang="scss" scoped>
.paper_search {
  display: flex;
  align-items: center;
  gap: 24px;
  margin-top: 40px;
  .paper_search_input {
    display: flex;
    align-items: center;
    gap: 10px;
    span {
      width: 80px;
      flex-shrink: 0;
      text-align: right;
      font-size: 14px;
      color: #333;
    }
    .el-input {
      width: 280px;
      flex-shrink: 0;
    }
  }
  /deep/.el-button {
    margin-left: 0;
    padding: 8px 20px;
  }
  /deep/ .reset.el-button--default {
    border-color: #ddd;
    background-color: #fff;
    color: #000;
  }
  /deep/ .reset.el-button--default:hover {
    background-color: #e40080;
    border-color: #e40080;
    color: #fff;
  }
}
.paper_add {
  margin: 40px 0;
  /deep/.el-button {
    margin-left: 0;
    padding: 8px 20px;
  }
}
.paper_actions {
  display: flex;
  align-items: center;
  span {
    margin-right: 10px;
    cursor: pointer;
    color: #1677ff;
    font-size: 14px;
  }
  span:hover {
    font-weight: 500;
  }
  span.delete {
    color: red;
  }
}
.paper_form_avatar {
  height: 150px;
  /deep/ .el-form-item__content {
    width: 180px;
    height: 180px;
  }
}
/deep/ .el-pagination {
  text-align: right;
  margin-right: 100px;
}
/deep/ .dialog-footer {
  .el-button--default:hover {
    background-color: #e40080;
    border-color: #e40080;
    color: #fff;
  }
}
</style>
